var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeartClient(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D5D4D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3403 4C9.4157 4 8.51439 4.46375 7.99994 5.15858C7.48546 4.46375 6.58417 4 5.65956 4C4.19311 4 3 5.19345 3 6.65956C3 9.06141 6.02609 11.3255 7.83002 12.4616L8 12.5688L8.16998 12.4616C9.97389 11.3255 13 9.06141 13 6.65956C13 5.19348 11.8068 4 10.3403 4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartClient);
export default __webpack_public_path__ + "static/media/heart-client.3cb1e205.svg";
export { ForwardRef as ReactComponent };